import React, {Component, useEffect} from 'react';
import FadeInSection from "./FadeInSection";
import banner from "../image/banner_compress.jpg";
import {Link} from "react-router-dom";
import fishImage from '../image/header5_compress.jpg';
import birdImage from "../image/bird_compress.jpg";
import fishCatalogue from "../catalogues/Atman Aquarium Product Catalogue.pdf";
import birdCageCatalogue from "../catalogues/Cage Product Catalogue.pdf";
import {useHistory} from "react-router-dom";

const scrollEventHandler = () => {
    let curPos = document.documentElement.scrollTop;
    let header = document.querySelector(".page-header.page-header-xs").scrollHeight;
    let dom = document.querySelector(".navbar.navbar-expand-lg.fixed-top");

    if (curPos > header / 2) {
        if (dom.classList.contains("navbar-transparent")) {
            dom.classList.remove("navbar-transparent");
        }
    } else {
        if (!dom.classList.contains("navbar-transparent")) {
            dom.classList.add("navbar-transparent");
        }
    }
};

const ChooseCatalogue = () => {
    useEffect(() => {
        window.addEventListener('scroll', scrollEventHandler);

        return () => {
            window.removeEventListener('scroll', scrollEventHandler);
        }
    }, []);

    return (
        <React.Fragment>
            <div className="main">
                <div className="section text-center">
                    <div className="container">
                        <FadeInSection>
                            <h2 className="title">Choose Catalogue</h2>
                        </FadeInSection>
                        <FadeInSection>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="card pointerCursor">
                                        <div className="card-body" onClick={() => {
                                            // window.open(fishCatalogue)
                                            window.open("/catalogue/aquarium", "_blank", "noopener");
                                        }}>
                                            <h4 className="card-title">
                                                {/*<a href={fishCatalogue} target="_blank">*/}
                                                {/*    <img src={fishImage} alt="Fish Catalogue" />*/}
                                                {/*</a>*/}

                                                <a target="_blank">
                                                    <img src={fishImage} alt="Fish Catalogue"/>
                                                </a>
                                            </h4>
                                            <p className="card-text" style={{
                                                "paddingTop": "15px",
                                                "paddingBottom": "0px",
                                            }}>
                                                {/*<a href={fishCatalogue} target="_blank">*/}
                                                {/*    Download Aquarium Product Catalogue*/}
                                                {/*</a>*/}

                                                <a target="_blank">
                                                    Download Aquarium Product Catalogue
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="card pointerCursor">
                                        <div className="card-body" onClick={() => {
                                            // window.open(birdCageCatalogue)
                                            window.open("/catalogue/cage", "_blank", "noopener");
                                        }}>
                                            <h4 className="card-title">
                                                {/*<a href={birdCageCatalogue} target="_blank">*/}
                                                {/*    <img src={birdImage} alt="Fish Catalogue" />*/}
                                                {/*</a>*/}
                                                <a target="_blank">
                                                    <img src={birdImage} alt="Fish Catalogue"/>
                                                </a>
                                            </h4>
                                            <p className="card-text" style={{
                                                "paddingTop": "15px",
                                                "paddingBottom": "0px",
                                            }}>
                                                {/*<a href={birdCageCatalogue} target="_blank">*/}
                                                {/*    Download Bird (& Pets) Cage Product Catalogue*/}
                                                {/*</a>*/}

                                                <a target="_blank">
                                                    Download Bird (& Pets) Cage Product Catalogue
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </FadeInSection>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
};

export default ChooseCatalogue;
